window.appConfig = {
  select2: {
    placeholder: 'Select topics',
    closeOnSelect: false,
    templateSelection: function (data) {
      return data.text
    },
  },
}

window.initSelect2 = function (config = {}) {
  const defaults = {
    selectSelector: '.select-multiselect',
    tagsBlockSelector: '.resources-head__tags',
    tagsItemsSelector: '.resources-head__tags .tags__items',
    dropdownParentSelector: '.filters-item__field',
    options: [],
    select2Options: window.appConfig.select2,
  }

  const finalConfig = {
    ...defaults,
    ...config,
    select2Options: {
      ...defaults.select2Options,
      ...(config.select2Options || {}),
    },
  }

  const $select = $(finalConfig.selectSelector)

  if (finalConfig.options && finalConfig.options.length > 0) {
    $select.empty()

    finalConfig.options.forEach((option) => {
      let value, text

      if (typeof option === 'string') {
        value = option
        text = option
      } else if (typeof option === 'object') {
        value = option.value || option.id
        text = option.text || option.label || option.name
      }

      $select.append(new Option(text, value, false, false))
    })
  }

  const select2Config = {
    ...finalConfig.select2Options,
    dropdownParent: $select.closest(finalConfig.dropdownParentSelector),
  }

  $select.select2(select2Config)

  initSelect2Handlers(finalConfig)
}

function initSelect2Handlers(config) {
  const $select = $(config.selectSelector)
  const $tagsBlock = $(config.tagsBlockSelector)
  const $tagsItems = $(config.tagsItemsSelector)

  function toggleTagsBlock() {
    const count = $select.val()?.length || 0

    if (count > 0) {
      $tagsBlock.removeClass('is-hidden')
    } else {
      $tagsBlock.addClass('is-hidden')
    }
  }

  function updateSelectionText() {
    const count = $select.val()?.length || 0
    const $container = $select.next('.select2-container')
    const $rendered = $container.find('.select2-selection__rendered')

    $rendered.find('.select2-selection__choice').remove()

    if (count === 0) {
      $rendered.html(
        `<span class="select2-selection__placeholder">${config.select2Options.placeholder}</span>`,
      )
    } else if (count === 1) {
      $rendered.html(
        '<span class="select2-selection__rendered-text">1 Category</span>',
      )
    } else {
      $rendered.html(
        `<span class="select2-selection__rendered-text">${count} Categories</span>`,
      )
    }

    toggleTagsBlock()
  }

  $select.on('select2:select', function (e) {
    const value = e.params.data.id
    const text = e.params.data.text

    const tag = `
    <div class="tag" data-value="${value}">
      <div class="tag__title">
        <span class="body-m">${text}</span>
      </div>
    </div>
  `

    $tagsItems.append(tag)
    updateSelectionText()
  })

  $select.on('select2:unselect', function (e) {
    const value = e.params.data.id
    $tagsItems.find(`.tag[data-value="${value}"]`).remove()
    updateSelectionText()
  })

  $(document).on('click', `${config.tagsBlockSelector} .tag`, function () {
    const tag = $(this)
    const value = tag.data('value')

    const values = $select.val() || []
    const newValues = values.filter((v) => v !== value)

    $select.val(newValues).trigger('change')
    tag.remove()
    updateSelectionText()
  })

  $select.on('select2:select select2:unselect', function () {
    $('.select2-selection__choice').hide()
  })

  updateSelectionText()
}

$(document).ready(function () {
  let iti = null

  if ($('#phone').length > 0) {
    const phoneInput = document.querySelector('#phone')

    iti = window.intlTelInput(phoneInput, {
      loadUtils: () =>
        import('https://cdn.jsdelivr.net/npm/intl-tel-input@25.12.5/build/js/utils.js'),
      dropdownContainer: document.body,
      showSelectedDialCode: false,
      initialCountry: 'us',
      strictMode: true,
    })

    iti.promise.then(function () {
      phoneInput.addEventListener('input', function () {
        this.value = this.value.replace(/[^\d\s\-]/g, '')
      })
    })

    function updateCountryName() {
      const countryData = iti.getSelectedCountryData()
      const countryNameEl = document.querySelector('.country-name__text')

      if (countryNameEl && countryData.name) {
        countryNameEl.textContent = countryData.iso2
      }
    }

    updateCountryName()

    phoneInput.addEventListener('countrychange', updateCountryName)

    phoneInput.addEventListener('open:countrydropdown', function () {
      const smoother = ScrollSmoother.get()
      if (smoother) {
        smoother.paused(true)
      }
    })

    phoneInput.addEventListener('close:countrydropdown', function () {
      const smoother = ScrollSmoother.get()
      if (smoother) {
        smoother.paused(false)
      }
    })
  }

  // Selector
  $('.select-styler').styler()

  $('#modal-search').on('shown.bs.modal', function () {
    $('.js-search-input').focus()
  })

  $('#modal-search').on('hidden.bs.modal', function () {
    $('.js-search-input').val('')
  })

  if ($('.form-wrapper').length !== 0) {
    const $form = $('.form-wrapper form')
    const $subscribeBtn = $('.form-wrapper .btn-primary')
    const $successMessage = $('.success-message')
    const $errorMessage = $('.error-message')
    const endPointId = $('html').attr('data-wf-site')
    const pageId = $('html').attr('data-wf-page')
    const formType = $form.attr('data-name')
    const elementId = $form.attr('data-wf-element-id')
    const domain = window.location.hostname

    const errorMessages = {
      required: 'This field is required',
      email: 'Please enter a valid email address',
      checkbox: 'Please accept to continue',
    }

    function isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(email)
    }

    function showError($input, message) {
      clearError($input)
      $input.addClass('inp-error')

      const $errorText = $(
        '<div class="inp-group__error">' + message + '</div>',
      )

      if ($input.attr('type') === 'checkbox') {
        const $wrapper = $input.closest('.checkbox-wrapper, .w-checkbox')
        if ($wrapper.length) {
          $wrapper.after($errorText)
        } else {
          $input.parent().after($errorText)
        }
      } else {
        $input.after($errorText)
      }
    }

    function clearError($input) {
      $input.removeClass('inp-error')

      if ($input.attr('type') === 'checkbox') {
        const $wrapper = $input.closest('.checkbox-wrapper, .w-checkbox')
        if ($wrapper.length) {
          $wrapper.siblings('.inp-group__error').remove()
        } else {
          $input.parent().siblings('.inp-group__error').remove()
        }
      } else {
        $input.siblings('.inp-group__error').remove()
      }
    }

    $form.on('input', 'input, textarea, select', function () {
      clearError($(this))
    })

    $form.on('change', 'input[type="checkbox"]', function () {
      clearError($(this))
    })

    if ($subscribeBtn.length && $form.length) {
      $subscribeBtn.on('click', async function (e) {
        e.preventDefault()

        let isValid = true
        let $firstError = null

        $form.find('[required]').each(function () {
          const $input = $(this)
          const inputType = $input.attr('type')

          if (inputType === 'checkbox') {
            if (!$input.is(':checked')) {
              showError($input, errorMessages.checkbox)
              isValid = false
              if (!$firstError) $firstError = $input
            } else {
              clearError($input)
            }
            return
          }

          const value = $input.val() ? $input.val().trim() : ''

          if (!value) {
            showError($input, errorMessages.required)
            isValid = false
            if (!$firstError) $firstError = $input
            return
          }

          if (inputType === 'email' || $input.attr('name') === 'email') {
            if (!isValidEmail(value)) {
              showError($input, errorMessages.email)
              isValid = false
              if (!$firstError) $firstError = $input
              return
            }
          }

          clearError($input)
        })

        if (!isValid) {
          $firstError.focus()

          setTimeout(() => {
            $form.find('.inp-error').each(function () {
              clearError($(this))
            })
          }, 5000)

          return
        }

        const formData = new FormData($form[0])
        const data = new URLSearchParams()

        data.append('name', formType)
        data.append('source', window.location.href)
        data.append('test', 'false')
        data.append('dolphin', 'false')
        if (pageId) data.append('pageId', pageId)

        if (elementId) {
          data.append('elementId', elementId)
        }

        if (typeof window.formType !== 'undefined' && window.formType) {
          data.append('fields[form_type]', window.formType)
        }
        
        data.append('domain', domain)

        $form.find('input, textarea, select').each(function () {
          const $input = $(this)
          const name = $input.attr('name')
          const inputType = $input.attr('type')

          if (name && name !== 'cf-turnstile-response') {
            if (inputType === 'checkbox') {
              data.append(
                'fields[' + name + ']',
                $input.is(':checked') ? 'true' : 'false',
              )
            } else if (name === 'phone') {
              if (iti) {
                const countryData = iti.getSelectedCountryData()
                const dialCode = countryData.dialCode
                const phoneValue = $input.val().replace(/\D/g, '')
                const fullNumber = '+' + dialCode + phoneValue
                data.append('fields[phone]', fullNumber)
              } else {
                data.append('fields[phone]', $input.val())
              }
            } else {
              data.append('fields[' + name + ']', $input.val())
            }
          }
        })

        const turnstileResponse = formData.get('cf-turnstile-response')
        if (turnstileResponse) {
          data.append('fields[cf-turnstile-response]', turnstileResponse)
        }

        // if (window.formType) {
        //   data.append('fields[form_type]', window.formType)
        // }

        try {
          const response = await fetch(
            `https://webflow.com/api/v1/form/${endPointId}`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
              body: data.toString(),
            },
          )

          if (response.ok) {
            $successMessage.removeClass('is-hidden')
            $form[0].reset()

            setTimeout(() => {
              $successMessage.addClass('is-hidden')
            }, 10000)
          } else {
          }
        } catch (error) {}
      })
    }
  }

  gsap.registerPlugin(ScrollTrigger, ScrollSmoother)

  const mm = gsap.matchMedia()

  mm.add('(min-width: 480px)', () => {
    ScrollSmoother.create({
      wrapper: '.page-wrapper',
      content: '.main-wrapper',
      smooth: 1.5,
      effects: true,
      smoothTouch: false,
    })
  })

  if ($(window).width() >= 479) {
    gsap.utils.toArray('[data-fade="up"]').forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 90%',
          toggleActions: 'play none none none',
        },
        opacity: 0,
        y: 40,
        duration: 1.6,
        ease: 'expo.out',
        delay: element.dataset.delay || 0,
      })
    })

    if ('[data-fade="down"]') {
      gsap.utils.toArray('[data-fade="down"]').forEach((element) => {
        gsap.from(element, {
          scrollTrigger: {
            trigger: element,
            start: 'top 90%',
            toggleActions: 'play none none none',
          },
          opacity: 0,
          y: -40,
          duration: 1.6,
          ease: 'expo.out',
          delay: element.dataset.delay || 0,
        })
      })
    }

    if ('[data-fade="left"]') {
      gsap.utils.toArray('[data-fade="left"]').forEach((element) => {
        gsap.from(element, {
          scrollTrigger: {
            trigger: element,
            start: 'top 90%',
            toggleActions: 'play none none none',
          },
          opacity: 0,
          x: -40,
          duration: 1.6,
          ease: 'expo.out',
          delay: element.dataset.delay || 0,
        })
      })
    }

    if ('[data-fade="right"]') {
      gsap.utils.toArray('[data-fade="right"]').forEach((element) => {
        gsap.from(element, {
          scrollTrigger: {
            trigger: element,
            start: 'top 90%',
            toggleActions: 'play none none none',
          },
          opacity: 0,
          x: 40,
          duration: 1.6,
          ease: 'expo.out',
          delay: element.dataset.delay || 0,
        })
      })
    }

    if ('[data-fade="in"]') {
      gsap.utils.toArray('[data-fade="in"]').forEach((element) => {
        gsap.from(element, {
          scrollTrigger: {
            trigger: element,
            start: 'top 90%',
            toggleActions: 'play none none none',
          },
          opacity: 0,
          duration: 1.8,
          ease: 'power1.out',
          delay: element.dataset.delay || 0,
        })
      })
    }

    if ('[data-fade="scale"]') {
      gsap.utils.toArray('[data-fade="scale"]').forEach((element) => {
        gsap.from(element, {
          scrollTrigger: {
            trigger: element,
            start: 'top 90%',
            toggleActions: 'play none none none',
          },
          opacity: 0,
          scale: 0.9,
          duration: 1.8,
          ease: 'expo.out',
          delay: element.dataset.delay || 0,
        })
      })
    }

    if ('[data-fade="blur"]') {
      gsap.utils.toArray('[data-fade="blur"]').forEach((element) => {
        gsap.from(element, {
          scrollTrigger: {
            trigger: element,
            start: 'top 90%',
            toggleActions: 'play none none none',
          },
          opacity: 0,
          filter: 'blur(10px)',
          y: 30,
          duration: 2,
          ease: 'expo.out',
          delay: element.dataset.delay || 0,
        })
      })
    }

    if ('[data-fade="stagger"]') {
      gsap.utils.toArray('[data-fade="stagger"]').forEach((parent) => {
        const children = parent.children
        gsap.from(children, {
          scrollTrigger: {
            trigger: parent,
            start: 'top 90%',
            toggleActions: 'play none none none',
          },
          opacity: 0,
          y: 30,
          duration: 1.6,
          ease: 'expo.out',
          stagger: 0.15,
          delay: parent.dataset.delay || 0,
        })
      })
    }
  }

  // NAVIGATION
  const blogPostNav = document.querySelector('.blog-post-navigation')
  const textRichContent = document.querySelector('.rich-text')
  const textSidebar = document.querySelector('.blog-post__sidebar')
  const header = document.querySelector('.header')

  if (blogPostNav && textRichContent && textSidebar) {
    blogPostNav.innerHTML = ''

    const headings = textRichContent.querySelectorAll('h1, h2, h3, h4, h5, h6')
    const navItems = []

    headings.forEach((heading, index) => {
      if (!heading.id) {
        heading.id = `section-${index}`
      }

      const navItem = document.createElement('div')
      navItem.className = 'blog-post-navigation__item'

      if (index === 0) {
        navItem.classList.add('is-active')
      }

      navItem.innerHTML = `<div class="subtitle-14-m color-neutral-70">${heading.textContent}</div>`

      navItem.addEventListener('click', () => {
        const headerHeight = header ? header.offsetHeight : 0
        const isMobile = window.innerWidth < 480
        const sidebarHeight =
          isMobile && textSidebar ? textSidebar.offsetHeight : 0
        const targetPosition = heading.offsetTop - headerHeight - sidebarHeight

        if (isMobile) {
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth',
          })
        } else {
          smoother.scrollTo(targetPosition, true, 'top top')
        }
      })

      blogPostNav.appendChild(navItem)
      navItems.push(navItem)
    })

    const scrollActiveItemIntoView = (activeItem, container) => {
      if (!activeItem || !container) return

      const containerRect = container.getBoundingClientRect()
      const itemRect = activeItem.getBoundingClientRect()

      const isAbove = itemRect.top < containerRect.top
      const isBelow = itemRect.bottom > containerRect.bottom

      if (isAbove || isBelow) {
        const scrollTop = activeItem.offsetTop - container.offsetTop - 20

        container.scrollTo({
          top: scrollTop,
          behavior: 'smooth',
        })
      }
    }

    const updateActiveItem = () => {
      const headerHeight = header ? header.offsetHeight : 0
      const isMobile = window.innerWidth < 480
      const sidebarHeight =
        isMobile && textSidebar ? textSidebar.offsetHeight : 0
      const scrollPosition = window.scrollY + headerHeight + sidebarHeight + 100

      let activeIndex = 0

      for (let i = headings.length - 1; i >= 0; i--) {
        if (headings[i].offsetTop <= scrollPosition) {
          activeIndex = i
          break
        }
      }

      navItems.forEach((item, index) => {
        if (index === activeIndex) {
          item.classList.add('is-active')
          scrollActiveItemIntoView(item, blogPostNav)
        } else {
          item.classList.remove('is-active')
        }
      })
    }

    ScrollTrigger.create({
      trigger: textRichContent,
      start: 'top center',
      end: 'bottom center',
      onUpdate: updateActiveItem,
    })

    ScrollTrigger.matchMedia({
      '(min-width: 480px)': function () {
        const headerHeight = header ? header.offsetHeight : 0

        ScrollTrigger.create({
          trigger: textSidebar,
          start: `top ${headerHeight + 20}px`,
          end: () => {
            const navHeight = blogPostNav.offsetHeight
            const sidebarHeight = textSidebar.offsetHeight
            return `+=${sidebarHeight - navHeight}`
          },
          pin: '.blog-post-navigation',
          pinSpacing: false,
        })
      },
    })
  }

  // SOCIALS BUTTONS
  $('.blog-post-socials__item--link').on('click', function (e) {
    e.preventDefault()

    const url = window.location.href

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(url)
        .then(function () {})
        .catch(function (err) {})
    } else {
      const tempInput = $('<input>')
      $('body').append(tempInput)
      tempInput.val(url).select()
      document.execCommand('copy')
      tempInput.remove()
    }
  })

  $('.blog-post-socials__item--linkedin').on('click', function (e) {
    e.preventDefault()

    const url = encodeURIComponent(window.location.href)
    const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`

    window.open(linkedinUrl, '_blank', 'width=600,height=600')
  })

  $('.blog-post-socials__item--x').on('click', function (e) {
    e.preventDefault()

    const url = encodeURIComponent(window.location.href)
    const title = encodeURIComponent(document.title)
    const twitterUrl = `https://twitter.com/intent/tweet?url=${url}&text=${title}`

    window.open(twitterUrl, '_blank', 'width=600,height=600')
  })

  $('.blog-post-socials__item--fb').on('click', function (e) {
    e.preventDefault()

    const url = encodeURIComponent(window.location.href)
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`

    window.open(facebookUrl, '_blank', 'width=600,height=600')
  })

  if ($(window).width() <= 479) {
    $('.team-slider').slick({
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      variableWidth: true,
    })
  }

  let hideTimeout

  function closeMenu() {
    $('.header-nav__button').removeClass('is-active')
    $('.header-menu-wrapper').removeClass('is-active')

    if ($(window).width() > 479) {
      $('[data-menu-id]').removeClass('is-active')
    }

    $('body').removeClass('menu-open')
    $('html').removeClass('is-ovh')
    $('.btn-burger').removeClass('is-active')
  }

  $('.header-nav__button:not(".no-submenu")').on('mouseenter', function () {
    clearTimeout(hideTimeout)

    const menuId = $(this).attr('data-menu-show')

    closeMenu()

    $('.header-menu-wrapper').addClass('is-active')
    $('[data-menu-id="' + menuId + '"]').addClass('is-active')
    $(this).addClass('is-active')
  })

  $('.header-nav__button').on('mouseleave', function () {
    hideTimeout = setTimeout(closeMenu, 1)
  })

  $('.header-menu-wrapper').on('mouseenter', function (e) {
    clearTimeout(hideTimeout)

    const isOnMenu = $(e.target).closest('.header-menu').length > 0

    if (!isOnMenu) {
      closeMenu()
    }
  })

  $('.header-menu-wrapper').on('mousemove', function (e) {
    const isOnMenu = $(e.target).closest('.header-menu').length > 0

    if (!isOnMenu) {
      closeMenu()
    }
  })

  $('.header-menu-wrapper').on('mouseleave', function () {
    hideTimeout = setTimeout(closeMenu, 1)
  })

  if ($(window).width() <= 479) {
    $('.header-menu').on('click', function () {
      if ($(this).hasClass('is-open')) {
        $(this).removeClass('is-open')
      } else {
        $('.header-menu').removeClass('is-open')
        $(this).addClass('is-open')
      }
    })

    $('.btn-burger').on('click', function () {
      $('body').toggleClass('menu-open')
      $('html').toggleClass('is-ovh')
      $(this).toggleClass('is-active')
    })
  }

  // Share modal
  $('.blog-post-socials__item--share.mobile-visible').on('click', function (e) {
    e.preventDefault()
    $('.share-modal').addClass('is-active')
  })

  $('.share-modal').on('click', function (e) {
    if (!$(e.target).closest('.share-modal__in').length) {
      $(this).removeClass('is-active')
    }
  })

  $('.blog-post-socials__wrapper').on('click', function (e) {
    if (!$(e.target).hasClass('blog-post-socials__item')) {
      $(this).find('.blog-post-socials__item').get(0).click()
    }
  })

  $('[data-filter-category]').on('click', function () {
    window.location.href =
      '/blog?filter=' + encodeURIComponent($(this).data('filter-category'))
  })
  // FILTERS
  // // FILTERS - Оновлена версія з підтримкою всіх 4 розділів
  // if ($('.section__resources-head').length > 0) {
  //   ;(function () {
  //     let currentSort = 'Newest'

  //     function parseDate(dateStr) {
  //       if (!dateStr) return new Date(0)

  //       // Перевіряємо формат DD.MM.YYYY
  //       if (dateStr.includes('.')) {
  //         const parts = dateStr.split('.')
  //         return new Date(parts[2], parts[1] - 1, parts[0])
  //       }

  //       // Перевіряємо формат "January 20, 2026"
  //       const date = new Date(dateStr)
  //       return isNaN(date.getTime()) ? new Date(0) : date
  //     }

  //     function sortPosts($section, $postsContainer, $posts, sortType) {
  //       const postsArray = Array.from($posts.filter(':visible'))

  //       postsArray.sort((a, b) => {
  //         const aTitle = $(a).data('filter-title') || ''
  //         const bTitle = $(b).data('filter-title') || ''
  //         const aDate = $(a).data('filter-date') || ''
  //         const bDate = $(b).data('filter-date') || ''

  //         switch (sortType) {
  //           case 'Newest':
  //             return parseDate(bDate) - parseDate(aDate)
  //           case 'Created Date':
  //             return parseDate(aDate) - parseDate(bDate)
  //           case 'A to Z':
  //             return aTitle.toLowerCase().localeCompare(bTitle.toLowerCase())
  //           case 'Z to A':
  //             return bTitle.toLowerCase().localeCompare(aTitle.toLowerCase())
  //           default:
  //             return 0
  //         }
  //       })

  //       postsArray.forEach((post) => $postsContainer.append(post))
  //       $posts.filter(':hidden').appendTo($postsContainer)
  //     }

  //     function filterPosts($section, $postsContainer, $posts) {
  //       const selectedCategories = $('.select-multiselect').val() || []

  //       $posts.each(function () {
  //         const $post = $(this)
  //         const postCategory = $post.data('filter-category')

  //         if (
  //           selectedCategories.length === 0 ||
  //           selectedCategories.includes(postCategory)
  //         ) {
  //           $post.show()
  //         } else {
  //           $post.hide()
  //         }
  //       })

  //       checkEmptyState($postsContainer, $posts)
  //       sortPosts($section, $postsContainer, $posts, currentSort)
  //     }

  //     function checkEmptyState($postsContainer, $posts) {
  //       $postsContainer.find('.empty-state').remove()

  //       if ($posts.filter(':visible').length === 0) {
  //         $postsContainer.append(`
  //         <div class="empty-state" style="padding: 40px; text-align: center;">
  //           <div class="subtitle-20-m">No posts found</div>
  //           <div class="body-m color-neutral-70" style="margin-top: 8px;">Try selecting different categories</div>
  //         </div>
  //       `)
  //       }
  //     }

  //     // Ініціалізація для кожного розділу
  //     const sections = [
  //       {
  //         selector: '.section__resources-blog',
  //         container: '.case__items.case__items--compact',
  //         items: '.case-item',
  //       },
  //       {
  //         selector: '.section__resources-cases',
  //         container:
  //           '.case__items:not(.case__items--compact):not(.case__items--webinars)',
  //         items: '.case-item',
  //       },
  //       {
  //         selector: '.section__resources-white-paper',
  //         container: '.white-paper-items',
  //         items: '.white-paper-item',
  //       },
  //       {
  //         selector: '.section__resources-webinars',
  //         container: '.case__items.case__items--webinars',
  //         items: '.case-item',
  //       },
  //     ]

  //     sections.forEach((config) => {
  //       const $section = $(config.selector)
  //       if ($section.length === 0) return

  //       const $postsContainer = $section.find(config.container)
  //       if ($postsContainer.length === 0) return

  //       const $posts = $postsContainer.find(config.items).not('.slick-cloned')
  //       if ($posts.length === 0) return

  //       // Зберігаємо посилання для цього розділу
  //       $section.data('postsContainer', $postsContainer)
  //       $section.data('posts', $posts)
  //     })

  //     // Обробник сортування (загальний для всіх розділів)
  //     $('.select-styler')
  //       .parent()
  //       .find('ul li')
  //       .on('click', function () {
  //         const sortType = $(this).text().trim()
  //         if (!$(this).hasClass('disabled') && sortType !== 'Sort by') {
  //           currentSort = sortType

  //           sections.forEach((config) => {
  //             const $section = $(config.selector)
  //             const $postsContainer = $section.data('postsContainer')
  //             const $posts = $section.data('posts')

  //             if ($section.length && $postsContainer && $posts) {
  //               sortPosts($section, $postsContainer, $posts, sortType)
  //             }
  //           })
  //         }
  //       })

  //     // Обробник фільтрації по категоріях (загальний для всіх розділів)
  //     $('.select-multiselect').on('change', function () {
  //       sections.forEach((config) => {
  //         const $section = $(config.selector)
  //         const $postsContainer = $section.data('postsContainer')
  //         const $posts = $section.data('posts')

  //         if ($section.length && $postsContainer && $posts) {
  //           filterPosts($section, $postsContainer, $posts)
  //         }
  //       })
  //     })

  //     // Початкова фільтрація
  //     sections.forEach((config) => {
  //       const $section = $(config.selector)
  //       const $postsContainer = $section.data('postsContainer')
  //       const $posts = $section.data('posts')

  //       if ($section.length && $postsContainer && $posts) {
  //         filterPosts($section, $postsContainer, $posts)
  //       }
  //     })
  //   })()

  //   // SEARCH - Оновлена версія з груповим відображенням результатів
  //   ;(function () {
  //     const $searchInput = $('.js-search-input')
  //     const $searchModal = $('.modal-search')
  //     const $searchResults = $('.modal-search-popup')
  //     let allPostsBySection = {}
  //     let searchTimeout = null

  //     const sectionConfigs = [
  //       {
  //         name: 'Blog',
  //         selector: '.section__resources-blog',
  //         container: '.case__items.case__items--compact',
  //         items: '.case-item',
  //         titleSelector: '.subtitle-20-m',
  //         descriptionSelector: '.case-item__description .body-s',
  //       },
  //       {
  //         name: 'Case Studies',
  //         selector: '.section__resources-cases',
  //         container:
  //           '.case__items:not(.case__items--compact):not(.case__items--webinars)',
  //         items: '.case-item',
  //         titleSelector: '.heading-h5-m',
  //         descriptionSelector: '.case-item__description .body-m',
  //       },
  //       {
  //         name: 'White Papers & E-Books',
  //         selector: '.section__resources-white-paper',
  //         container: '.white-paper-items',
  //         items: '.white-paper-item',
  //         titleSelector: '.heading-h6-sb',
  //         descriptionSelector: '.body-m.color-neutral-70',
  //       },
  //       {
  //         name: 'Webinars',
  //         selector: '.section__resources-webinars',
  //         container: '.case__items.case__items--webinars',
  //         items: '.case-item',
  //         titleSelector: '.heading-h5-m',
  //         descriptionSelector: '.case-item__description .body-m',
  //       },
  //     ]

  //     function collectPosts() {
  //       allPostsBySection = {}

  //       sectionConfigs.forEach((config) => {
  //         const $section = $(config.selector)
  //         if ($section.length === 0) return

  //         const posts = []
  //         const $container = $section.find(config.container)

  //         $container
  //           .find(config.items)
  //           .not('.slick-cloned')
  //           .each(function () {
  //             const $post = $(this)

  //             const title =
  //               $post.data('filter-title') ||
  //               $post.find(config.titleSelector).first().text().trim()
  //             const category =
  //               $post.data('filter-category') ||
  //               $post.find('.label .body-s').first().text().trim()
  //             const description = $post
  //               .find(config.descriptionSelector)
  //               .first()
  //               .text()
  //               .trim()
  //             const image =
  //               $post
  //                 .find(
  //                   '.case-item__illustration, .white-paper-item__illustration',
  //                 )
  //                 .first()
  //                 .attr('src') || ''
  //             const srcset =
  //               $post
  //                 .find(
  //                   '.case-item__illustration, .white-paper-item__illustration',
  //                 )
  //                 .first()
  //                 .attr('srcset') || ''
  //             const link = $post.find('.btn-link').attr('href') || '#'

  //             posts.push({
  //               title,
  //               category,
  //               description,
  //               image,
  //               srcset,
  //               link,
  //               sectionName: config.name,
  //             })
  //           })

  //         if (posts.length > 0) {
  //           allPostsBySection[config.name] = posts
  //         }
  //       })
  //     }

  //     function renderPosts(postsBySection) {
  //       const totalPosts = Object.values(postsBySection).reduce(
  //         (sum, posts) => sum + posts.length,
  //         0,
  //       )

  //       // Очищуємо попередній вміст
  //       $searchResults.empty()

  //       if (totalPosts === 0) {
  //         $searchModal.addClass('is-empty')
  //         $searchResults.html(`
  //         <div style="padding: 40px; text-align: center;">
  //           <div class="subtitle-20-m">No results found</div>
  //           <div class="body-m color-neutral-70" style="margin-top: 0.5rem;">Try adjusting your keywords<br/> and search again</div>
  //         </div>
  //       `)
  //         return
  //       }

  //       $searchModal.removeClass('is-empty')

  //       let html = ''

  //       Object.entries(postsBySection).forEach(([sectionName, posts]) => {
  //         if (posts.length === 0) return

  //         html += `
  //         <div class="modal-search-popup-section">
  //           <div class="modal-search-popup-section__head">
  //             <div class="tiny-12 color-neutral-70">${sectionName}</div>
  //           </div>
  //           <div class="modal-search-popup-section__in">
  //       `

  //         posts.forEach((post) => {
  //           const hasImage = sectionName !== 'White Papers & E-Books'

  //           html += `
  //           <a href="${post.link}" class="modal-search-popup-item w-inline-block">
  //         `

  //           if (hasImage) {
  //             html += `
  //             <div class="modal-search-popup-item__visual">
  //               <img
  //                 src="${post.image}"
  //                 loading="lazy"
  //                 sizes="(max-width: 479px) 100vw, 239.984375px"
  //                 ${post.srcset ? `srcset="${post.srcset}"` : ''}
  //                 alt="${post.title}"
  //                 class="modal-search-popup-item__illustration">
  //             </div>
  //           `
  //           }

  //           html += `
  //             <div class="modal-search-popup-item__content">
  //               <div class="subtitle-14-m">${post.title}</div>
  //               <div class="tiny-12 color-neutral-70">${post.description.substring(0, 100)}${post.description.length > 100 ? '...' : ''}</div>
  //             </div>
  //           </a>
  //         `
  //         })

  //         html += `
  //           </div>
  //         </div>
  //       `
  //       })

  //       $searchResults.html(html)
  //     }

  //     function searchPosts(query) {
  //       if (!query || query.trim() === '') {
  //         renderPosts(allPostsBySection)
  //         return
  //       }

  //       const searchQuery = query.toLowerCase().trim()
  //       const filteredBySection = {}

  //       Object.entries(allPostsBySection).forEach(([sectionName, posts]) => {
  //         const filtered = posts.filter((post) => {
  //           return (
  //             post.title.toLowerCase().includes(searchQuery) ||
  //             post.description.toLowerCase().includes(searchQuery) ||
  //             post.category.toLowerCase().includes(searchQuery)
  //           )
  //         })

  //         if (filtered.length > 0) {
  //           filteredBySection[sectionName] = filtered
  //         }
  //       })

  //       renderPosts(filteredBySection)
  //     }

  //     $searchInput.off('input').on('input', function () {
  //       const query = $(this).val()

  //       clearTimeout(searchTimeout)
  //       searchTimeout = setTimeout(() => {
  //         searchPosts(query)
  //       }, 300)
  //     })

  //     $('#modal-search')
  //       .off('shown.bs.modal')
  //       .on('shown.bs.modal', function () {
  //         const smoother = ScrollSmoother.get()
  //         if (smoother) {
  //           smoother.paused(true)
  //         }

  //         collectPosts()
  //         renderPosts(allPostsBySection)
  //         $('.js-search-input').val('').focus()
  //       })

  //     $('#modal-search')
  //       .off('hidden.bs.modal')
  //       .on('hidden.bs.modal', function () {
  //         const smoother = ScrollSmoother.get()
  //         if (smoother) {
  //           smoother.paused(false)
  //         }

  //         $('.js-search-input').val('')
  //         $searchModal.removeClass('is-empty')
  //         $searchResults.empty()
  //       })
  //   })()
  // }

  if ($('.section__resources-head').length > 0) {
    ;(function () {
      let currentSort = 'Newest'

      function parseDate(dateStr) {
        if (!dateStr) return new Date(0)

        if (dateStr.includes('.')) {
          const parts = dateStr.split('.')
          return new Date(parts[2], parts[1] - 1, parts[0])
        }

        const date = new Date(dateStr)
        return isNaN(date.getTime()) ? new Date(0) : date
      }

      function sortPosts($section, $postsContainer, $posts, sortType) {
        const postsArray = Array.from($posts.filter(':visible'))

        postsArray.sort((a, b) => {
          const aTitle = $(a).data('filter-title') || ''
          const bTitle = $(b).data('filter-title') || ''
          const aDate = $(a).data('filter-date') || ''
          const bDate = $(b).data('filter-date') || ''

          switch (sortType) {
            case 'Newest':
              return parseDate(bDate) - parseDate(aDate)
            case 'Created Date':
              return parseDate(aDate) - parseDate(bDate)
            case 'A to Z':
              return aTitle.toLowerCase().localeCompare(bTitle.toLowerCase())
            case 'Z to A':
              return bTitle.toLowerCase().localeCompare(aTitle.toLowerCase())
            default:
              return 0
          }
        })

        postsArray.forEach((post) => $postsContainer.append(post))
        $posts.filter(':hidden').appendTo($postsContainer)
      }

      function filterPosts($section, $postsContainer, $posts) {
        const selectedCategories = $('.select-multiselect').val() || []

        $posts.each(function () {
          const $post = $(this)
          const postCategory = $post.data('filter-category')

          if (
            selectedCategories.length === 0 ||
            selectedCategories.includes(postCategory)
          ) {
            $post.show()
          } else {
            $post.hide()
          }
        })

        checkEmptyState($postsContainer, $posts)
        sortPosts($section, $postsContainer, $posts, currentSort)
      }

      function checkEmptyState($postsContainer, $posts) {
        $postsContainer.find('.empty-state').remove()

        if ($posts.filter(':visible').length === 0) {
          $postsContainer.append(`
          <div class="empty-state" style="padding: 40px; text-align: center; grid-column: 1 / -1;">
            <div class="subtitle-20-m">No posts found</div>
            <div class="body-m color-neutral-70" style="margin-top: 8px;">Try selecting different categories</div>
          </div>
        `)
        }
      }

      const sections = [
        {
          selector: '.section__resources-blog',
          container: '.case__items.case__items--compact',
          items: '.case-item',
        },
        {
          selector: '.section__resources-cases',
          container:
            '.case__items:not(.case__items--compact):not(.case__items--webinars)',
          items: '.case-item',
        },
        {
          selector: '.section__resources-white-paper',
          container: '.white-paper-items',
          items: '.white-paper-item',
        },
        {
          selector: '.section__resources-webinars',
          container: '.case__items.case__items--webinars',
          items: '.case-item',
        },
      ]

      sections.forEach((config) => {
        const $section = $(config.selector)
        if ($section.length === 0) return

        const $postsContainer = $section.find(config.container)
        if ($postsContainer.length === 0) return

        const $posts = $postsContainer.find(config.items).not('.slick-cloned')
        if ($posts.length === 0) return

        $section.data('postsContainer', $postsContainer)
        $section.data('posts', $posts)
      })

      function filterSectionsByType(contentType) {
        const typeToSection = {
          Blog: '.section__resources-blog',
          Cases: '.section__resources-cases',
          'White Papers': '.section__resources-white-paper',
          Webinars: '.section__resources-webinars',
        }

        if (
          !contentType ||
          contentType === 'Select type' ||
          contentType === 'All types'
        ) {
          $(
            '.section__resources-blog, .section__resources-cases, .section__resources-white-paper, .section__resources-webinars',
          ).show()
        } else {
          $(
            '.section__resources-blog, .section__resources-cases, .section__resources-white-paper, .section__resources-webinars',
          ).hide()

          const sectionSelector = typeToSection[contentType]
          if (sectionSelector) {
            $(sectionSelector).show()
          }
        }
      }

      $('.select-styler')
        .parent()
        .find('ul li')
        .on('click', function () {
          const sortType = $(this).text().trim()
          if (!$(this).hasClass('disabled') && sortType !== 'Sort by') {
            currentSort = sortType

            sections.forEach((config) => {
              const $section = $(config.selector)
              const $postsContainer = $section.data('postsContainer')
              const $posts = $section.data('posts')

              if ($section.length && $postsContainer && $posts) {
                sortPosts($section, $postsContainer, $posts, sortType)
              }
            })
          }
        })

      $('.select-multiselect').on('change', function () {
        sections.forEach((config) => {
          const $section = $(config.selector)
          const $postsContainer = $section.data('postsContainer')
          const $posts = $section.data('posts')

          if ($section.length && $postsContainer && $posts) {
            filterPosts($section, $postsContainer, $posts)
          }
        })
      })

      sections.forEach((config) => {
        const $section = $(config.selector)
        const $postsContainer = $section.data('postsContainer')
        const $posts = $section.data('posts')

        if ($section.length && $postsContainer && $posts) {
          filterPosts($section, $postsContainer, $posts)
        }
      })

      $('.filters-item--first .select-styler')
        .parent()
        .find('ul li')
        .on('click', function () {
          const contentType = $(this).text().trim()

          if (!$(this).hasClass('disabled')) {
            filterSectionsByType(contentType)
          }
        })

      filterSectionsByType('All types')
      ;(function () {
        const currentPath = window.location.pathname

        const pathToType = {
          '/blog': 'Blog',
          '/cases': 'Cases',
          '/white-papers': 'White Papers',
          '/webinars': 'Webinars',
        }

        let selectedType = null
        for (let path in pathToType) {
          if (currentPath.includes(path)) {
            selectedType = pathToType[path]
            break
          }
        }

        if (selectedType) {
          $('.filters-item--first .select-styler')
            .parent()
            .find('ul li')
            .each(function () {
              const optionText = $(this).text().trim()

              if (optionText === selectedType) {
                $(this).show()
              } else {
                $(this).hide()
              }
            })

          $('.filters-item--first .jq-selectbox__select-text').text(
            selectedType,
          )
          filterSectionsByType(selectedType)
        }
      })()
    })()
    ;(function () {
      const $searchInput = $('.js-search-input')
      const $searchModal = $('.modal-search')
      const $searchResults = $('.modal-search-popup')
      let allPostsBySection = {}
      let searchTimeout = null

      const sectionConfigs = [
        {
          name: 'Blog',
          selector: '.section__resources-blog',
          container: '.case__items.case__items--compact',
          items: '.case-item',
          titleSelector: '.subtitle-20-m',
          descriptionSelector: '.case-item__description .body-s',
        },
        {
          name: 'Case Studies',
          selector: '.section__resources-cases',
          container:
            '.case__items:not(.case__items--compact):not(.case__items--webinars)',
          items: '.case-item',
          titleSelector: '.heading-h5-m',
          descriptionSelector: '.case-item__description .body-m',
        },
        {
          name: 'White Papers & E-Books',
          selector: '.section__resources-white-paper',
          container: '.white-paper-items',
          items: '.white-paper-item',
          titleSelector: '.heading-h6-sb',
          descriptionSelector: '.body-m.color-neutral-70',
        },
        {
          name: 'Webinars',
          selector: '.section__resources-webinars',
          container: '.case__items.case__items--webinars',
          items: '.case-item',
          titleSelector: '.heading-h5-m',
          descriptionSelector: '.case-item__description .body-m',
        },
      ]

      function collectPosts() {
        allPostsBySection = {}

        sectionConfigs.forEach((config) => {
          const $section = $(config.selector)
          if ($section.length === 0) return

          const posts = []
          const $container = $section.find(config.container)

          $container
            .find(config.items)
            .not('.slick-cloned')
            .each(function () {
              const $post = $(this)

              const title =
                $post.data('filter-title') ||
                $post.find(config.titleSelector).first().text().trim()
              const category =
                $post.data('filter-category') ||
                $post.find('.label .body-s').first().text().trim()
              const description = $post
                .find(config.descriptionSelector)
                .first()
                .text()
                .trim()
              const image =
                $post
                  .find(
                    '.case-item__illustration, .white-paper-item__illustration',
                  )
                  .first()
                  .attr('src') || ''
              const srcset =
                $post
                  .find(
                    '.case-item__illustration, .white-paper-item__illustration',
                  )
                  .first()
                  .attr('srcset') || ''
              const link = $post.find('.btn-link').attr('href') || '#'

              posts.push({
                title,
                category,
                description,
                image,
                srcset,
                link,
                sectionName: config.name,
              })
            })

          if (posts.length > 0) {
            allPostsBySection[config.name] = posts
          }
        })
      }

      function renderPosts(postsBySection) {
        const totalPosts = Object.values(postsBySection).reduce(
          (sum, posts) => sum + posts.length,
          0,
        )

        $searchResults.empty()

        if (totalPosts === 0) {
          $searchModal.addClass('is-empty')
          $searchResults.html(`
          <div style="padding: 40px; text-align: center; grid-column: 1 / -1;">
            <div class="subtitle-20-m">No results found</div>
            <div class="body-m color-neutral-70" style="margin-top: 0.5rem;">Try adjusting your keywords<br/> and search again</div>
          </div>
        `)
          return
        }

        $searchModal.removeClass('is-empty')

        let html = ''

        Object.entries(postsBySection).forEach(([sectionName, posts]) => {
          if (posts.length === 0) return

          html += `
          <div class="modal-search-popup-section">
            <div class="modal-search-popup-section__head">
              <div class="tiny-12 color-neutral-70">${sectionName}</div>
            </div>
            <div class="modal-search-popup-section__in">
        `

          posts.forEach((post) => {
            const hasImage = sectionName !== 'White Papers & E-Books'

            html += `
            <a href="${post.link}" class="modal-search-popup-item w-inline-block">
          `

            if (hasImage) {
              html += `
              <div class="modal-search-popup-item__visual">
                <img 
                  src="${post.image}" 
                  loading="lazy" 
                  sizes="(max-width: 479px) 100vw, 239.984375px" 
                  ${post.srcset ? `srcset="${post.srcset}"` : ''}
                  alt="${post.title}" 
                  class="modal-search-popup-item__illustration">
              </div>
            `
            }

            html += `
              <div class="modal-search-popup-item__content">
                <div class="subtitle-14-m">${post.title}</div>
                <div class="tiny-12 color-neutral-70">${post.description.substring(0, 100)}${post.description.length > 100 ? '...' : ''}</div>
              </div>
            </a>
          `
          })

          html += `
            </div>
          </div>
        `
        })

        $searchResults.html(html)
      }

      function searchPosts(query) {
        if (!query || query.trim() === '') {
          renderPosts(allPostsBySection)
          return
        }

        const searchQuery = query.toLowerCase().trim()
        const filteredBySection = {}

        Object.entries(allPostsBySection).forEach(([sectionName, posts]) => {
          const filtered = posts.filter((post) => {
            return (
              post.title.toLowerCase().includes(searchQuery) ||
              post.description.toLowerCase().includes(searchQuery) ||
              post.category.toLowerCase().includes(searchQuery)
            )
          })

          if (filtered.length > 0) {
            filteredBySection[sectionName] = filtered
          }
        })

        renderPosts(filteredBySection)
      }

      $searchInput.off('input').on('input', function () {
        const query = $(this).val()

        clearTimeout(searchTimeout)
        searchTimeout = setTimeout(() => {
          searchPosts(query)
        }, 300)
      })

      $('#modal-search')
        .off('shown.bs.modal')
        .on('shown.bs.modal', function () {
          const smoother = ScrollSmoother.get()
          if (smoother) {
            smoother.paused(true)
          }

          collectPosts()
          renderPosts(allPostsBySection)
          $('.js-search-input').val('').focus()
        })

      $('#modal-search')
        .off('hidden.bs.modal')
        .on('hidden.bs.modal', function () {
          const smoother = ScrollSmoother.get()
          if (smoother) {
            smoother.paused(false)
          }

          $('.js-search-input').val('')
          $searchModal.removeClass('is-empty')
          $searchResults.empty()
        })
    })()
  }

  // ANCHOR SCROLL
  ;(function () {
    const urlParams = new URLSearchParams(window.location.search)
    const anchor = urlParams.get('anchor')

    if (!anchor) return

    const targetElement = document.getElementById(anchor)

    if (!targetElement) {
      return
    }

    function scrollToAnchor() {
      const header = document.querySelector('.header')
      const headerHeight = header ? header.offsetHeight : 0
      const isMobile = window.innerWidth < 480

      if (isMobile) {
        const targetPosition = targetElement.offsetTop - headerHeight
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth',
        })
      } else {
        let attempts = 0
        const maxAttempts = 20

        const checkSmoother = setInterval(() => {
          const smoother = ScrollSmoother.get()
          attempts++

          if (smoother) {
            clearInterval(checkSmoother)
            smoother.scrollTo(targetElement, true, `top ${headerHeight}px`)
          } else if (attempts >= maxAttempts) {
            clearInterval(checkSmoother)
            // Fallback
            const targetPosition = targetElement.offsetTop - headerHeight
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth',
            })
          }
        }, 100)
      }
    }

    window.addEventListener('load', () => {
      setTimeout(scrollToAnchor, 300)
    })
  })()
})
